<template>
  <div class="contact">
    <div class="container">
      <div class="contact__wrapper">
        <div class="contact__left">
          <h2 class="contact__title">
            {{ t('home.contact.title') }}
            <img src="@images/vectors/contact/yellowVector.svg" alt="vector" class="image contact__left-image1">
          </h2>
          <div class="contact__info">
            <a class="contact__info-item" :href="'mailto:' + companyEmail">{{ companyEmail }}</a>
            <a class="contact__info-item" :href="'tel:' + companyPhone">{{ companyPhone }}</a>
            <p class="contact__info-item">{{ companyAddress }}</p>
            <p class="contact__info-text">{{ t('home.contact.text') }}</p>
          </div>
          <img src="@images/vectors/contact/topBlueVector.svg" alt="vector" class="image contact__left-image2">
          <img src="@images/vectors/contact/purpleStar.svg" alt="star" class="image contact__left-image3">
          <img src="@images/vectors/contact/greenVector.svg" alt="vector" class="image contact__left-image4">
          <img src="@images/vectors/contact/pinkVector.svg" alt="vector" class="image contact__left-image5">
          <img src="@images/vectors/contact/bottomBlueVector.svg" alt="vector" class="image contact__left-image6">
          <img src="@images/vectors/contact/yellowStar.svg" alt="star" class="image contact__left-image7">
        </div>
        <div class="contact__right" id="contact">
          <img src="@images/vectors/contact/topPart1.svg" alt="vector" class="image contact__right-top-part1">
          <img src="@images/vectors/contact/topPart2.svg" alt="vector" class="image contact__right-top-part2">
          <img src="@images/vectors/contact/topPart3.svg" alt="vector" class="image contact__right-top-part3">
          <img src="@images/vectors/contact/topPart4.svg" alt="vector" class="image contact__right-top-part4">
          <img src="@images/vectors/contact/topPart5.svg" alt="vector" class="image contact__right-top-part5">
          <img src="@images/vectors/contact/topPart6.svg" alt="vector" class="image contact__right-top-part6">
          <img src="@images/vectors/contact/bottomPart1.svg" alt="vector" class="image contact__right-bottom-part1">
          <img src="@images/vectors/contact/bottomPart2.svg" alt="vector" class="image contact__right-bottom-part2">
          <img src="@images/vectors/contact/bottomPart3.svg" alt="vector" class="image contact__right-bottom-part3">
          <img src="@images/vectors/contact/bottomPart4.svg" alt="vector" class="image contact__right-bottom-part4">
          <contact-form />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {useCompanyStore} from "@/stores/company.js";
import {computed} from "vue";
import ContactForm from "@/components/forms/contact-form.vue";

const {t} = useI18n()
const companyStore = useCompanyStore()

const company = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : ""
})
const companyEmail = computed(() => {
  return company.value?.emailFrom || '';
});
const companyPhone = computed(() => {
  return company.value?.companyPhoneNumber || '';
});
const companyAddress = computed(() => {
  return company.value?.companyAddress || '';
});
</script>

<style lang="scss" scoped>
.contact {
  padding-block: 110px 80px;

  &__wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }

  &__left {
    max-width: 650px;
    display: flex;
    flex-direction: column;
    gap: 100px;
    position: relative;

    &-image1 {
      bottom: -15px;
      left: -40px;
    }
    &-image2 {
      top: 80px;
      right: -100px;
    }
    &-image3 {
      top: 170px;
      right: 90px;
    }
    &-image4 {
      width: 80px;
      top: 180px;
      right: -50px;
    }
    &-image5 {
      bottom: -73px;
      right: -66px;
    }
    &-image6 {
      left: -85px;
      bottom: -80px;
    }
    &-image7 {
      left: -60px;
      top: 275px;
    }
  }

  &__title {
    position: relative;
    font-family: Poppins, sans-serif;
    font-size: 64px;
    font-weight: 700;
    color: #2a2a2a;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 20px;

    & a {
      @include hover {
        color: #1f1f1f;
      }
    }

    &-item {
      text-transform: uppercase;
      font-family: Nunito, sans-serif;
      font-size: 18px;
      font-weight: 400;
      color: #4a4a4a;
    }

    &-text {
      text-align: justify;
      font-family: Poppins,sans-serif;
      font-size: 18px;
      font-weight: 400;
      color: #4a4a4a;
    }
  }

  &__right {
    position: relative;

    &-top-part1 {
      top: -17px;
      right: 70px;
    }
    &-top-part2 {
      top: -17px;
      right: 25px;
    }
    &-top-part3 {
      top: -17px;
      right: -15px;
    }
    &-top-part4 {
      top: 18px;
      right: -15px;
    }
    &-top-part5 {
      top: 65px;
      right: -15px;
    }
    &-top-part6 {
      top: 115px;
      right: -15px;
    }
    &-bottom-part1 {
      bottom: 70px;
      left: -15px;
    }
    &-bottom-part2 {
      bottom: 30px;
      left: -15px;
    }
    &-bottom-part3 {
      bottom: -10px;
      left: -15px;
    }
    &-bottom-part4 {
      bottom: -13px;
      left: 17px;
    }
  }
}

.image {
  position: absolute;
}

@media (max-width: 1680px) {
  .contact {
    &__wrapper {
      justify-content: space-between;
    }
  }
}

@media (max-width: 1300px) {
  .contact {
    &__wrapper {
      flex-direction: column;
      gap: 50px;
    }

    &__left {
      &-image2 {
        top: unset;
        right: unset;
        left: -60px;
        bottom: -90px;
      }

      &-image6 {
        display: none;
      }
    }
  }
}

@media (max-width: 800px) {
  .contact {
    &__left {
      width: 90%;
      gap: 50px;

      &-image2 {
        display: none;
      }
      &-image5 {
        display: none;
      }
    }
  }
}

@media (max-width: 600px) {
  .contact {
    &__left {
      &-image3 {
        display: none;
      }
    }
  }
}

@media (max-width: 450px) {
  .contact {
    padding-block: 50px 75px;

    &__title {
      font-size: 48px;
    }

    &__left {
      &-image1 {
        width: 100%;
        left: unset;
        right: 0;
      }
      &-image4 {
        display: none;
      }
      &-image7 {
        display: none;
      }
    }

    &__right {
      display: grid;
      place-items: center;
    }
  }
}
</style>